export enum PersonalInfoFields {
  firstName = 'firstName',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  email = 'email',
  locationPreferences = 'locationPreferences',
  birthday = 'birthday',
  streetAddress = 'streetAddress',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
}
